export default __webpack_public_path__ + "static/Kontaktseite-81c2b5b55e4720f4d1523c0ebcb8cd8b.jpg";